import React, { SVGProps } from 'react';

export const IconStop = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M26 6.5a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v19c0 .28.22.5.5.5h19a.5.5 0 0 0 .5-.5v-19Z"/></svg>;
